import { pdfPreviewAssets } from "./pdfPreviewAssets";
export const pdfPreviews = [
  {
    "id": "3",
    "page": "03",
    "label": "30-minute agenda",
    "heading": "The full session is already timed",
    "text": "Opening, demonstration, three role rotations, debrief and application are mapped into 30 minutes, with guidance for different group sizes.",
    "alt": "Actual PDF page 3: The 30-minute session, with a timeline and role rotation order."
  },
  {
    "id": "23",
    "page": "23",
    "label": "Facilitator plan",
    "heading": "Know what to say at every stage",
    "text": "The Clear Work Handoffs workshop includes the objective, framework, preparation and exact facilitator wording for each part of the session.",
    "alt": "Actual PDF page 23: Workshop 4 Clear Work Handoffs facilitator plan and timed script."
  },
  {
    "id": "24",
    "page": "24",
    "label": "Printable role cards",
    "heading": "The practice scenario and roles are written",
    "text": "A complete workplace scenario gives the speaker, listener and observer their facts, instructions and behavior checks.",
    "alt": "Actual PDF page 24: Clear Work Handoffs Case A, with speaker, listener and observer cards."
  },
  {
    "id": "31",
    "page": "31",
    "label": "Model conversation",
    "heading": "A complete example to demonstrate",
    "text": "The misunderstanding scenario includes a model dialogue, a less useful response, a clearer alternative and ready debrief questions.",
    "alt": "Actual PDF page 31: Workshop 5 model conversation and debrief for clearing up a misunderstanding."
  },
  {
    "id": "22",
    "page": "22",
    "label": "Observation & application",
    "heading": "The feedback sheet is ready too",
    "text": "Three observable behaviors, a feedback sentence, a completed example and application fields help participants turn practice into a concrete next action.",
    "alt": "Actual PDF page 22: Workshop 3 observation and application sheet with behavior checks and a completed example."
  }
].map(page => ({ ...page, src: pdfPreviewAssets[page.id] }));
